<template>
    <div class="summaries" v-if="showSummaries">
        <ModuleContainer
            v-if="showTalkSummary"
            module="Feedback"
            icon="fas fa-comment-dots"
        >
            <TalkSummary :userId="user.id" :periods="periods" />
        </ModuleContainer>
        <ModuleContainer
            v-if="showPdiSummary"
            module="PDI"
            icon="fas fa-mountain"
            class="pdi-container"
        >
            <PdiSummary :userId="user.id" :periods="periods" />
        </ModuleContainer>
    </div>
</template>
<script>
import ModuleContainer from './components/ModuleContainer'
import { PdiSummary, TalkSummary } from '@/views/components/summaries'
export default {
    components: {
        PdiSummary,
        TalkSummary,
        ModuleContainer,
    },
    props: {
        user: Object,
        periods: Array,
    },
    computed: {
        showSummaries() {
            return this.showTalkSummary || this.showPdiSummary
        },
        showTalkSummary() {
            return this.currentUser.has_talk && this.user.has_talk
        },
        showPdiSummary() {
            return this.currentUser.has_pdi && this.user.has_pdi
        },
        currentUser() {
            return this.$store.state.currentUser.user
        },
    },
}
</script>
<style scoped>
.summaries {
    margin-top: 16px;
}

.pdi-container {
    margin-top: 16px;
}
</style>
